/* ============================================
   HN PDP details: "Pairs well with" cards.
   Option change updates the card price; Add posts one unit to
   /cart/add.js with the drawer sections, swaps them in the same way
   hn-pdp-main and the offer pages do, then opens the drawer.
   _hn_source marks the line for order attribution.
   ============================================ */

(function () {
  if (window.__hnPdpDetailsInit) return;
  window.__hnPdpDetailsInit = true;

  var SOURCE = 'PDP pairs well with';

  function swapDrawerSections(sections) {
    var liveDrawer = document.querySelector('cart-drawer');

    if (sections['cart-drawer']) {
      var drawerDoc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var freshInner = drawerDoc.querySelector('#CartDrawer');
      var liveInner = document.querySelector('#CartDrawer');
      if (freshInner && liveInner) liveInner.innerHTML = freshInner.innerHTML;
      var freshDrawer = drawerDoc.querySelector('cart-drawer');
      if (liveDrawer && freshDrawer) {
        liveDrawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
      }
      var overlay = document.querySelector('#CartDrawer-Overlay');
      if (overlay && liveDrawer && typeof liveDrawer.close === 'function') {
        overlay.addEventListener('click', liveDrawer.close.bind(liveDrawer));
      }
    }

    if (sections['cart-icon-bubble']) {
      var bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var freshBubble = bubbleDoc.querySelector('.shopify-section');
      var liveBubble = document.querySelector('#cart-icon-bubble');
      if (freshBubble && liveBubble) liveBubble.innerHTML = freshBubble.innerHTML;
    }

    return liveDrawer;
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('select[data-hn-pair-variant]');
    if (!select) return;
    var card = select.closest('[data-hn-pair]');
    var option = select.options[select.selectedIndex];
    if (!card || !option) return;
    var price = card.querySelector('[data-hn-pair-price]');
    var compare = card.querySelector('[data-hn-pair-compare]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-hn-pair-add]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    var card = button.closest('[data-hn-pair]');
    var variantInput = card && card.querySelector('[data-hn-pair-variant]');
    var label = button.querySelector('[data-hn-pair-add-label]');
    var status = card && card.querySelector('[data-hn-pair-status]');
    if (!variantInput || !variantInput.value) return;

    var idleLabel = label ? label.textContent : '';
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding';
    if (status) status.textContent = '';

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantInput.value), quantity: 1, properties: { _hn_source: SOURCE } }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          return data;
        });
      })
      .then(function (data) {
        var drawer = swapDrawerSections(data.sections || {});
        if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hn-pdp-details', cartData: data });
        }
        if (label) label.textContent = 'Added';
        if (drawer && typeof drawer.open === 'function') {
          drawer.open(button);
        } else if (status) {
          status.textContent = 'Added to your cart.';
        }
        window.setTimeout(function () {
          if (label) label.textContent = idleLabel;
        }, 2400);
      })
      .catch(function (error) {
        console.error('[hn-pdp-details] add failed:', error);
        if (label) label.textContent = idleLabel;
        if (status) status.textContent = 'That did not go through. Please try again.';
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  });
})();
